module.exports = __webpack_public_path__ + "img/info.2c25118c.svg";